// Shared Framer Motion presets so every section animates the same way.
export const ease = [0.22, 1, 0.36, 1];

export const spring = { type: "spring", stiffness: 260, damping: 24 };

// Fire once, slightly before the element is fully on screen.
export const viewport = { once: true, amount: 0.2, margin: "0px 0px -60px 0px" };

export const stagger = (staggerChildren = 0.1, delayChildren = 0) => ({
  hidden: {},
  visible: { transition: { staggerChildren, delayChildren } },
});

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease } },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.8, ease } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease } },
};

export const slideInRight = {
  hidden: { opacity: 0, x: 40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease } },
};

// Text that rises out of an overflow-hidden mask (wrap in .reveal-mask).
export const maskRise = {
  hidden: { y: "110%" },
  visible: { y: 0, transition: { duration: 0.9, ease } },
};

// Pressable controls (buttons, social icons).
export const press = {
  whileHover: { scale: 1.05 },
  whileTap: { scale: 0.96 },
  transition: spring,
};
